import {
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';

/** Same annotation the github-actions, github-insights and github-compliance cards key off. */
const PROJECT_SLUG_ANNOTATION = 'github.com/project-slug';

const coverageCard = EntityCardBlueprint.make({
  name: 'coverage',
  params: {
    filter: (entity: { metadata?: { annotations?: Record<string, string> } }) =>
      Boolean(entity.metadata?.annotations?.[PROJECT_SLUG_ANNOTATION]),
    loader: async () => {
      const { CoverageCard } = await import('./features/coverage-card');
      return compatWrapper(<CoverageCard />);
    },
  },
});

export const codeCoveragePlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'code-coverage',
  extensions: [coverageCard],
});
